// src/pages/Menu.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/Auth.css";
import AuthNav from "../components/AuthNav";

const Menu = () => {
  const { t } = useTranslation("menu");
  const [activeTab, setActiveTab] = useState("breakfast");

  // public 目录里的两张图片
  const breakfastImg = "/menuBreakfast.png";
  const mainImg = "/menuMain.png";

  const currentImage = activeTab === "breakfast" ? breakfastImg : mainImg;

  return (
    <div className="auth-background">
      {/* 顶部四个导航按钮：完全复用原来的 AuthNav */}
      <AuthNav />

      {/* 中间白色菜单卡片 */}
      <div className="menu-card">

        {/* 早 / 正 两个按钮，风格类似“登录 / 注册” */}
        <div className="menu-switch-row">
          <button
            type="button"
            className={
              "menu-switch-button" +
              (activeTab === "breakfast"
                ? " menu-switch-button--active"
                : "")
            }
            onClick={() => setActiveTab("breakfast")}
          >
            {t("tabs.breakfast")}
          </button>

          <button
            type="button"
            className={
              "menu-switch-button" +
              (activeTab === "main" ? " menu-switch-button--active" : "")
            }
            onClick={() => setActiveTab("main")}
          >
            {t("tabs.main")}
          </button>
        </div>

        {/* 菜单图片：在白色框里，内部可以滚动 */}
        <div className="menu-image-wrapper">
          <img
            className="menu-image"
            src={currentImage}
            alt={activeTab === "breakfast" ? "Breakfast Menu" : "Main Menu"}
          />
        </div>
      </div>
    </div>
  );
};

export default Menu;
